import { IRequirementsModel, RequirementError, RequirementsModel } from "src/app/pages/one-way-data/request/requirements-model";
import { LocationModel } from "src/app/models/container_master_model/location";
import { ServiceMasterModel } from "src/app/models/common/service-master.model";
import { PhoneModel } from "src/app/models/common/phone-model";
import { RejectionReasonModel } from "src/app/models/common/myteam-model";
import { IInviteModelForLeadVerification, InviteModelForLeadVerification, LeadInviteModelErrors } from "./lead-invite.model";
import { DomainCode } from "src/app/models/common/model";

export interface ILeadVerificationModel {
    id?: string;
    pol_list: string[];
    pod_list: string[];
    request_type: string;
    transaction_type: string;
    email: string;
    request_source: string;
    mobile: string;
    token?: string;
    requirements?: IRequirementsModel[];
    csc_revalidation_required?: boolean;
    rejection_reason: string;
    remarks: string;
    lead_status: boolean;
    invite?: IInviteModelForLeadVerification;

    client_browser: string;
    client_device: string;
    client_ip: string;
    is_active?: boolean;
    created_at?: Date;
    created_by?: string;
    updated_at?: Date;
    updated_by?: string;
}

export interface LeadVerificationError {
    pol_list: string[];
    pod_list: string[];
    request_type: string[];
    transaction_type: string[];
    email: string[];
    mobile: string[];
    requirements: RequirementError[];
    csc_revalidation_required: string[];
    lead_status: string[];
    invite: LeadInviteModelErrors;
    rejection_reason: string[];
    remarks: string[];
    request_source: string[];
}

export class LeadVerificationModel {
    id?: string;
    pol_list: LocationModel[];
    pod_list: LocationModel[];
    request_type: ServiceMasterModel;
    transaction_type: DomainCode;
    email: string;
    request_source: string;
    mobile: PhoneModel;
    requirements?: RequirementsModel[];
    csc_revalidation_required?: boolean;
    rejection_reason: RejectionReasonModel;
    remarks: string;
    lead_status: any;
    lead_status_display:any;
    invite?: InviteModelForLeadVerification;
    lead_number?: string;

    client_browser?: string;
    client_device?: string;
    client_location?: string;
    client_ip?: string;
    is_active?: boolean;
    created_at?: Date;
    created_by?: string;
    updated_at?: Date;
    updated_by?: string;

    error: LeadVerificationError;

    // leadApprovalList = [
    //     {
    //         id: true,
    //         value: 'Approved'
    //     },
    //     {
    //         id: false,
    //         value: 'Rejected'
    //     }
    // ]
    // leadApprovalList = [
    //     {
    //         id: 'approved',
    //         value: 'Approved'
    //     },
    //     {
    //         id: 'rejected',
    //         value: 'Rejected'
    //     }
    // ];

    constructor() {
        this.pol_list = [];
        this.pod_list = [];
        this.request_type = null;
        this.transaction_type = null;
        this.request_source = 'Customer Portal';
        this.mobile = null;
        this.email = null;
        this.requirements = [new RequirementsModel()];
        this.csc_revalidation_required = true;
        this.rejection_reason = null;
        this.remarks = null;
        this.lead_status = null;
        this.lead_status_display = null;
        this.invite = new InviteModelForLeadVerification();

        this.resetErrors();
    }

    resetErrors() {
        this.error = {
            pol_list: [],
            pod_list: [],
            request_type: [],
            transaction_type: [],
            email: [],
            mobile: [],
            requirements: [new RequirementError()],
            csc_revalidation_required: [],
            lead_status: [],
            invite: new LeadInviteModelErrors(),
            rejection_reason: [],
            remarks: [],
            request_source: [],
        }
    }

    is_lead_valid() {
        this.resetErrors();
        if (this.lead_status == 'approved') {
            if (this.request_type == null) {
                this.error.request_type.push('Please select a request type');
            }

            if (this.transaction_type == null && this.request_type.dev_name != 'lease') {
                this.error.transaction_type.push('Please select a transaction type');
            }

            if (this.email == null || this.email == '') {
                this.error.email.push('Please enter an email to continue');
            }

            if (this.mobile == null) {
                this.error.mobile.push('Please enter mobile number to continue');
            }

            if (this.pol_list.length < 1) {
                this.error.pol_list.push('Please select at least one Port');
            }

            if (this.request_type.dev_name != 'buy_sell') {
                if (this.pod_list.length < 1) {
                    this.error.pod_list.push('Please select at least one Port');
                }
            }

            return this.error.request_type.length == 0 &&
                this.error.transaction_type.length == 0 &&
                this.error.email.length == 0 &&
                this.error.mobile.length == 0 &&
                this.error.pol_list.length == 0 &&
                this.error.pod_list.length == 0
        } else {
            if (this.lead_status == null) {
                this.error.lead_status.push('Lead Status is required');
            }

            if (this.rejection_reason == null) {
                this.error.rejection_reason.push('Decline reason is required');
            }

            if (this.remarks == null || this.remarks == '') {
                this.error.remarks.push('Remarks is required');
            }

            return this.error.rejection_reason.length == 0 &&
                this.error.remarks.length == 0
        }
    }

    saveFirstLeadPayloadToModel(data) {
        this.id = data?.id;
        this.invite = new InviteModelForLeadVerification();
        this.invite.saveFirstPayload(data.invite);
        this.is_active = data.is_active;
        this.pol_list = data.pol_list;
        this.pod_list = data.pod_list;
        this.request_type = data.request_type;
        this.transaction_type = data.transaction_type;
        this.email = data.email;
        this.mobile = data.mobile;
        this.rejection_reason = data.rejection_reason;
        this.remarks = data.remarks;
        this.lead_status = data.lead_status;
        this.lead_status_display = data.lead_status_display;
        this.lead_number = data.lead_number;
        this.requirements = data.requirements.map((item) => new RequirementsModel(item));

        this.client_browser = data.client_browser;
        this.client_device = data.client_device;
        this.client_location = data.client_location;
        this.client_ip = data.client_ip;
        this.created_at = data.created_at;
        this.created_by = data.created_by;
        this.updated_at = data.updated_at;
        this.updated_by = data.updated_by;
    }

    saveLeadPayloadToModel(data) {
        this.id = data.id;
        this.invite = new InviteModelForLeadVerification(data.invite);
        this.is_active = data.is_active;
        this.pol_list = data.pol_list;
        this.pod_list = data.pod_list;
        this.request_type = data.request_type;
        this.transaction_type = data.transaction_type;
        this.email = data.email;
        this.mobile = data.mobile;
        this.rejection_reason = data.rejection_reason;
        this.remarks = data.remarks;
        this.lead_status = data.lead_status;
        this.lead_status_display = data.lead_status_display;
        // this.lead_status = data.lead_status ? this.leadApprovalList[0] : this.leadApprovalList[1];
        this.requirements = data.requirements.map((item) => new RequirementsModel(item));
        this.lead_number = data.lead_number;

        this.client_browser = data.client_browser;
        this.client_device = data.client_device;
        this.client_location = data.client_location;
        this.client_ip = data.client_ip;
        this.created_at = data.created_at;
        this.created_by = data.created_by;
        this.updated_at = data.updated_at;
        this.updated_by = data.updated_by;
        this.request_source = data.request_source;

    }

    getVerificationSavePayload() {
        if (this.lead_status) {
            return {
                invite: this.invite.getUserVerificationSavePayload(),
                request_type: this.request_type.id,
                transaction_type: typeof this.transaction_type == 'object' && this.transaction_type != null ? this.transaction_type.dev_value : this.transaction_type,
                pol_list: this.pol_list.map((item) => item.id),
                pod_list: this.pod_list.map((item) => item.id),
                mobile: this.mobile.as_e164,
                rejection_reason: typeof this.rejection_reason == 'object' && this.rejection_reason != null ? this.rejection_reason.id : this.rejection_reason,
                remarks: this.remarks,
                // lead_status: this.lead_status,
                lead_status : typeof this.lead_status == 'object' && this.lead_status != null ? this.lead_status.value : this.lead_status,
                requirements: this.request_type.dev_name == 'one_way' ? this.requirements.map((item) => item.getOneWayRequirementPayload()) : this.request_type.dev_name == 'buy_sell' ? this.requirements.map((item) => item.getTradeRequirementPayload()) : this.requirements.map((item) => item.getLeaseRequirementPayload()),
            }
        } else {
            return {
                invite: this.invite.getUserVerificationSavePayload(),
                request_type: this.request_type.id,
                transaction_type: typeof this.transaction_type == 'object' && this.transaction_type != null ? this.transaction_type.dev_value : this.transaction_type,
                pol_list: this.pol_list.map((item) => item.id),
                pod_list: this.pod_list.map((item) => item.id),
                mobile: this.mobile.as_e164,
                rejection_reason: typeof this.rejection_reason == 'object' && this.rejection_reason != null ? this.rejection_reason.id : this.rejection_reason,
                remarks: this.remarks,
                // lead_status: this.lead_status,
                lead_status : typeof this.lead_status == 'object' && this.lead_status != null ? this.lead_status.value : this.lead_status,
                requirements: this.request_type.dev_name == 'one_way' ? this.requirements.map((item) => item.getOneWayRequirementPayload()) : this.request_type.dev_name == 'buy_sell' ? this.requirements.map((item) => item.getTradeRequirementPayload()) : this.requirements.map((item) => item.getLeaseRequirementPayload()),
            }

        }
    }
}